import {DataStatus} from 'platform/components';
import {Show} from 'platform/foundation';

import {isNotNil} from 'ramda-adjunct';

import {useGetSautoPlatformQuery, useSautoAuthenticateMutation} from '@dms/api/sales';
import {AdvertisingPlatformCodeEnum} from '@dms/api/shared';
import {featureFlags} from '@dms/feature-flags';
import {useBranchId} from '@dms/settings/shared';
import {handleApiError} from '@dms/shared';

import {
  PlatformAuthenticationForm,
  PlatformAuthenticationFormProps,
} from './components/PlatformAuthenticationForm';
import {PlatformPhotoSettings} from './components/PlatformPhotoSettings';
import {PlatformSAutoManufacturedOn} from './components/PlatformSAutoManufacturedOn';

export function PlatformSettingsSauto() {
  const branchId = useBranchId();
  const params = {branchId};
  const {data, isLoading, isError} = useGetSautoPlatformQuery({params});
  const [saveAuthentication] = useSautoAuthenticateMutation();

  const onSubmitCredentials: PlatformAuthenticationFormProps['onSubmit'] = (values) =>
    saveAuthentication({
      body: values,
      params,
    })
      .unwrap()
      .catch(handleApiError);

  return (
    <Show whenFeatureEnabled={featureFlags.ADVERTISEMENT_GENERAL_SETTINGS}>
      <DataStatus isLoading={isLoading} isError={isError}>
        {isNotNil(data) && (
          <PlatformAuthenticationForm
            defaultValues={data.credentials}
            onSubmit={onSubmitCredentials}
          />
        )}
        <PlatformPhotoSettings platformCode={AdvertisingPlatformCodeEnum.SAUTO} />
        <PlatformSAutoManufacturedOn />
      </DataStatus>
    </Show>
  );
}
